
import { EntityDto } from '../../services/dto/entityDto';
import { GetAllTenantOutput } from './dto/getAllTenantOutput';
import { PagedResultDto } from '../../services/dto/pagedResultDto';
import { PagedTenantResultRequestDto } from './dto/PagedTenantResultRequestDto';
import http from '../httpService';
import { TenantRecordDto } from './dto/tenantRecordDto';
import { FileUpload } from '../dto/fileActionResultDto'; 

class TenantService {
  public async create(createTenantInput: any): Promise<any> {
    let result = await http.post('api/services/app/Tenant/Create', createTenantInput);
    return result.data.result;
  }

  public async delete(entityDto: EntityDto) {
    let result = await http.delete('api/services/app/Tenant/Delete', { params: entityDto });
    return result.data;
  }

  public async get(entityDto: EntityDto): Promise<any> {
    let result = await http.get('api/services/app/Tenant/Get', { params: entityDto }); 
    return result.data.result;
  }

  public async getAll(pagedFilterAndSortedRequest: PagedTenantResultRequestDto): Promise<PagedResultDto<GetAllTenantOutput>> {
    let result = await http.get('api/services/app/Tenant/GetAll', { params: pagedFilterAndSortedRequest });
    return result.data.result;
  }

  public async update(updateTenantInput: any): Promise<any> {
    let result = await http.put('api/services/app/Tenant/Update', updateTenantInput);
    return result.data.result;
  }

  //------------------------------------------------------------------

  public async updateRecord(askDto: TenantRecordDto): Promise<PagedResultDto<TenantRecordDto>> {
    let getRecordsResult = await http.put('api/services/app/TenantRecord/Update', askDto);
    return getRecordsResult.data.result;
  }

  public async uploadImage(file: FormData): Promise<FileUpload> {
    let getResult = await http.post('api/services/app/Tenant/UploadFile', file);
    return getResult.data.result;
  }

  public async getImage(id: number): Promise<FileUpload> {
    let getResult = await http.get('api/services/app/Tenant/GetFile?id=' + id);
    return getResult.data.result;
  }
 
}

export default new TenantService();
